import installationInstructions from "./installationInstructions";

const ew020Content = {
    installationInstructions
};

export { ew020Content };
